module.exports = __webpack_public_path__ + "0594b41a9fbeab8c1b3c43e37455455c.svg";